/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.video.rpc.HubSpotVideoSearchRpc
 */

import type {
  ChirpAvroRpcDetails,
  Requestify,
  unhandledEnumCase,
  Default,
  HubspotMetadata,
} from 'rpc-client-utils';

/**
 * Record for com.hubspot.chirp.core.CausalChainLink
 */
export type CausalChainLink = {
  coordinates: ChirpMethodCoordinates;
  errorClass: string;
  errorMessage?: string;
};

/**
 * Record for com.hubspot.chirp.core.ChirpMethodCoordinates
 */
export type ChirpMethodCoordinates = { service: string; method: string };

export type EmptyError = {
  chirpErrorMessage?: string;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry?: boolean;
};

export type FilterOperator =
  | 'EQ'
  | 'NEQ'
  | 'LT'
  | 'LTE'
  | 'GT'
  | 'GTE'
  | 'BETWEEN'
  | 'IN'
  | 'NOT_IN'
  | 'HAS_PROPERTY'
  | 'NOT_HAS_PROPERTY'
  | 'ROLLING_DATE_RANGE'
  | 'TIME_UNIT_TO_DATE'
  | 'BEFORE_ROLLING_DATE_POINT'
  | 'AFTER_ROLLING_DATE_POINT'
  | 'LT_X_DAYS'
  | 'GT_X_DAYS'
  | 'CONTAINS_ALL'
  | 'DOES_NOT_CONTAIN_ALL'
  | 'IS_EXACTLY'
  | 'IS_NOT_EXACTLY'
  | 'EQ_PROPERTY'
  | 'NEQ_PROPERTY'
  | 'LT_PROPERTY'
  | 'LTE_PROPERTY'
  | 'GT_PROPERTY'
  | 'GTE_PROPERTY'
  | unhandledEnumCase;

export type SortOrder = 'ASC' | 'DESC' | unhandledEnumCase;

export type SceneInfo = {
  people: Default<string[]>;
  visibleObjects: Default<string[]>;
  timeContext: Default<string[]>;
  actions: Default<string[]>;
  onScreenText: Default<string[]>;
  locations: Default<string[]>;
  brandsMentioned: Default<string[]>;
  context: Default<string[]>;
  miscellaneous: Default<Record<string, string[]>>;
};

export type Timestamp = { startTimeSeconds: number; endTimeSeconds: number };

export type VideoScene = {
  timestamp: Timestamp;
  sceneInfo: SceneInfo;
  thumbnailUrl: string;
};

export type MuxStatus =
  | 'preparing'
  | 'ready'
  | 'errored'
  | 'not_sent_to_mux'
  | 'mux_ingestion_task_enqueued'
  | unhandledEnumCase;

export type ConsolidatedVideoEntity = {
  portalId: number;
  crmObjectId: number;
  sourceFileId: number;
  sourceFileUrl: string;
  sourceFileSize: number;
  videoId: number;
  duration?: number;
  title: string;
  seoTitle?: string;
  primaryPlaybackId?: string;
  height?: number;
  width?: number;
  sourceFileBitrate?: number;
  sourceFileFrameRate?: string;
  posterUrl?: string;
  transcodingState?: MuxStatus;
  createdAt: number;
  updatedAt: number;
  deletedAt: number;
  isEmbeddable?: boolean;
  hasShareKey?: boolean;
  muxUpdatedAt: number;
  thumbnailSourceFileId?: number;
  thumbnailUrl?: string;
  thumbnailSourceMilliseconds?: number;
  subtitleLanguageCodes: Default<string[]>;
  mp4FileUrl?: string;
  tags: Default<string[]>;
  description?: string;
  folderId?: number;
  folderPath?: string;
  chapters?: SeoChapters;
  sourceFileLanguageCode?: string;
  sourceFileStreams: Default<FileMetadataStream[]>;
  sourceFileAllowsAnonymousAccess?: boolean;
  visibility?: VideoVisibility;
  videoType?: VideoType;
  videoOrigin?: VideoOrigin;
  thirdPartyOriginAppId?: number;
  videoAttributes: Default<VideoAttribute[]>;
  fileExtension?: string;
  muxAssetId?: string;
};

export type FileIdRequest = { sourceFileId: number };

export type FileMetadataStream = {
  codecName?: string;
  codecLongName?: string;
  codecType: CodecType;
  profile?: string;
  codecTimeBase?: string;
  width: number;
  height: number;
  duration: number;
  bitrate: number;
  startTime: number;
  displayAspectRatio?: string;
  sampleAspectRatio?: string;
  timeBase?: string;
  frameRate?: string;
  avgFrameRate?: string;
  sampleRate: number;
  channels: number;
  rotation: number;
  tags: Default<Record<string, string>>;
};

export type VideoAttribute =
  | 'DUBBED'
  | 'TRANSLATED'
  | 'AI_SUGGESTED'
  | 'EDITED'
  | 'TIKTOK_AUDIO_AVAILABLE'
  | unhandledEnumCase;

export type VideoOrigin =
  | 'UPLOAD'
  | 'THIRD_PARTY'
  | 'CLIP_EDITOR'
  | 'CAPTURE'
  | unhandledEnumCase;

export type VideoVisibility =
  | 'PUBLIC'
  | 'PUBLIC_NO_INDEX'
  | 'PRIVATE'
  | 'ANYONE_WITH_LINK'
  | unhandledEnumCase;

export type CodecType = 'AUDIO' | 'VIDEO' | unhandledEnumCase;

export type ConsolidatedVideoEntityPagedResultWithTotal = {
  total: number;
  results: Default<ConsolidatedVideoEntity[]>;
  hasMore: boolean;
  offset: number;
};

export type SearchProperty =
  | 'FILE_NAME'
  | 'SEO_TITLE'
  | 'ASPECT_RATIO'
  | 'DURATION'
  | 'CREATED_AT'
  | 'UPDATED_AT'
  | 'LANGUAGE'
  | 'FILE_EXTENSION'
  | 'VIDEO_TYPE'
  | 'CAMPAIGN_GUID'
  | 'SOURCE_FILE_ID'
  | 'VIDEO_ID'
  | 'WIDTH'
  | 'HEIGHT'
  | 'SUBTITLE_LANGUAGE_CODES'
  | unhandledEnumCase;

export type SortOrderForObjectsMissingField =
  | 'FIRST'
  | 'LAST'
  | unhandledEnumCase;

export type VideoFieldSort = {
  property: SearchProperty;
  sortOrderForObjectsMissingField?: SortOrderForObjectsMissingField;
  order: SortOrder;
};

export type VideoSearchFilter = {
  operator: FilterOperator;
  property: SearchProperty;
  value?: string;
  values: Default<string[]>;
  highValue?: string;
  comparisonProperty?: SearchProperty;
  shouldMatchExactly: Default<boolean>;
};

export type VideoSearchFilterGroup = { filters: Default<VideoSearchFilter[]> };

export type VideoSearchRequest = {
  count: number;
  offset: number;
  filterGroups: Default<VideoSearchFilterGroup[]>;
  sorts: Default<VideoFieldSort[]>;
};

export type AdvancedSearchRequest = {
  fileId?: number;
  query: string;
  topK: Default<number>;
  searchType: SearchType;
};

export type AdvancedSearchResponse = {
  searchResults: Default<AdvancedSearchResult[]>;
};

export type AdvancedSearchResult = {
  portalId: number;
  sourceFileId: number;
  startTimeSeconds: number;
  endTimeSeconds: number;
  score: number;
  thumbnailUrl?: string;
  visualSearchSemanticScore?: number;
  visualSearchKeywordMatchScore?: number;
  transcriptScore?: number;
  visualSearchRrfScore?: number;
  hybridSearchRrfScore?: number;
  confidenceScore: Default<ConfidenceScore>;
};

export type AdvancedSearchResultWithVideo = {
  video: ConsolidatedVideoEntity;
  searchResult: AdvancedSearchResult;
};

export type AdvancedSearchWithVideosResponse = {
  results: Default<AdvancedSearchResultWithVideo[]>;
};

export type ConfidenceScore = 'HIGH' | 'MEDIUM' | 'LOW' | unhandledEnumCase;

export type EmbeddedVectorsResponse = {
  fileId: number;
  videoSceneInfos: Default<VideoScene[]>;
};

export type ReprocessVideosForVisualSearchRequest = {
  fileIds: Default<number[]>;
};

export type ReprocessVideosForVisualSearchResponse = {
  reEnqueuedFileIds: Default<number[]>;
  fileIdsFailedToReEnqueue: Default<number[]>;
};

export type SearchType = 'VISUAL' | 'TRANSCRIPT' | 'HYBRID' | unhandledEnumCase;

export type Chapter = { startTime: number; title: string };

export type SeoChapters = { items: Default<Chapter[]> };

export type VideoType = 'ORIGINAL_VIDEO' | 'CLIP' | unhandledEnumCase;

export type SearchRequestType = Requestify<VideoSearchRequest>;
export type SearchResponseType = ConsolidatedVideoEntityPagedResultWithTotal;
export type SearchErrorType = EmptyError & HubspotMetadata;
export const searchRpc: ChirpAvroRpcDetails<
  SearchRequestType,
  SearchResponseType,
  SearchErrorType,
  false
> = {
  serviceName: 'com.hubspot.video.rpc.HubSpotVideoSearchRpc',
  rpcName: 'search',
  auth: 'app',
  fingerprint: 'xj9zpEokaBHrKFs3cbCpnZwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type AdvancedSearchRequestType = Requestify<AdvancedSearchRequest>;
export type AdvancedSearchResponseType = AdvancedSearchResponse;
export type AdvancedSearchErrorType = EmptyError & HubspotMetadata;
export const advancedSearchRpc: ChirpAvroRpcDetails<
  AdvancedSearchRequestType,
  AdvancedSearchResponseType,
  AdvancedSearchErrorType,
  false
> = {
  serviceName: 'com.hubspot.video.rpc.HubSpotVideoSearchRpc',
  rpcName: 'advancedSearch',
  auth: 'app',
  fingerprint: '0HQyoRzyjSDf83Gmf1482JwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type AdvancedSearchWithVideosHydratedRequestType =
  Requestify<AdvancedSearchRequest>;
export type AdvancedSearchWithVideosHydratedResponseType =
  AdvancedSearchWithVideosResponse;
export type AdvancedSearchWithVideosHydratedErrorType = EmptyError &
  HubspotMetadata;
export const advancedSearchWithVideosHydratedRpc: ChirpAvroRpcDetails<
  AdvancedSearchWithVideosHydratedRequestType,
  AdvancedSearchWithVideosHydratedResponseType,
  AdvancedSearchWithVideosHydratedErrorType,
  false
> = {
  serviceName: 'com.hubspot.video.rpc.HubSpotVideoSearchRpc',
  rpcName: 'advancedSearchWithVideosHydrated',
  auth: 'app',
  fingerprint: '0HQyoRzyjSBsIHLpy4pIIZwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type GetEmbeddedVectorsForVideoRequestType = Requestify<FileIdRequest>;
export type GetEmbeddedVectorsForVideoResponseType = EmbeddedVectorsResponse;
export type GetEmbeddedVectorsForVideoErrorType = EmptyError & HubspotMetadata;
export const getEmbeddedVectorsForVideoRpc: ChirpAvroRpcDetails<
  GetEmbeddedVectorsForVideoRequestType,
  GetEmbeddedVectorsForVideoResponseType,
  GetEmbeddedVectorsForVideoErrorType,
  false
> = {
  serviceName: 'com.hubspot.video.rpc.HubSpotVideoSearchRpc',
  rpcName: 'getEmbeddedVectorsForVideo',
  auth: 'app',
  fingerprint: 'ATWAZeIns-nRAJHdJKV2IJwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type ReprocessVideosForVisualSearchRequestType =
  Requestify<ReprocessVideosForVisualSearchRequest>;
export type ReprocessVideosForVisualSearchResponseType =
  ReprocessVideosForVisualSearchResponse;
export type ReprocessVideosForVisualSearchErrorType = EmptyError &
  HubspotMetadata;
export const reprocessVideosForVisualSearchRpc: ChirpAvroRpcDetails<
  ReprocessVideosForVisualSearchRequestType,
  ReprocessVideosForVisualSearchResponseType,
  ReprocessVideosForVisualSearchErrorType,
  false
> = {
  serviceName: 'com.hubspot.video.rpc.HubSpotVideoSearchRpc',
  rpcName: 'reprocessVideosForVisualSearch',
  auth: 'app',
  fingerprint: 'M30cV0GJB7R4cOwYGhQuHZwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};
